var _circle, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3334,
    cy: 35,
    r: 35,
    fill: "#D9F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 37C19.3334 35.8954 20.2288 35 21.3334 35H25.3334C26.4379 35 27.3334 35.8954 27.3334 37V47C27.3334 48.1046 26.4379 49 25.3334 49H21.3334C20.2288 49 19.3334 48.1046 19.3334 47V37Z",
    fill: "#005370"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3334 29C31.3334 27.8954 32.2288 27 33.3334 27H37.3334C38.4379 27 39.3334 27.8954 39.3334 29V47C39.3334 48.1046 38.4379 49 37.3334 49H33.3334C32.2288 49 31.3334 48.1046 31.3334 47V29Z",
    fill: "#005370"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3334 23C43.3334 21.8954 44.2288 21 45.3334 21H49.3334C50.4379 21 51.3334 21.8954 51.3334 23V47C51.3334 48.1046 50.4379 49 49.3334 49H45.3334C44.2288 49 43.3334 48.1046 43.3334 47V23Z",
    fill: "#005370"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2342_49791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3334 17L28.8334 26.5L23.8334 21.5L16.3334 29M38.3334 17H32.3334M38.3334 17V23",
    stroke: "#2B7D9A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2342_49791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(15.3334 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitIcon);
export default __webpack_public_path__ + "static/media/ProfitIcon.e344b46f98e51d09c321d9475ed4fab7.svg";
export { ForwardRef as ReactComponent };